import { render, staticRenderFns } from "./MostOrderedFromPartner.vue?vue&type=template&id=15715a04&"
import script from "./MostOrderedFromPartner.vue?vue&type=script&lang=js&"
export * from "./MostOrderedFromPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports